import { useContext } from 'react';
import useQuery, { Query, QueryOptions } from './useQuery';
import { UserQuerySpec } from './useUserQuery';
import { LoginType, UserContext, UserStatus } from '../UserAccess/UserContext';

export interface UserQueryOptions<Resp> extends QueryOptions<Resp> {
  rewriteToEmployeeApi?: boolean;
}

export default function useUserOrEmployeeQuery<Resp>(
  spec: UserQuerySpec,
  options?: UserQueryOptions<Resp>)
: Query<Resp> {
  const userStatus = useContext<UserStatus>(UserContext);

  let headers: (() => Promise<Headers>) | null = userStatus.user?.fetchHeaders ?? null;
  const rewriteToEmployeeApi = options?.rewriteToEmployeeApi ?? true;
  let path = spec.path;

  if (rewriteToEmployeeApi && userStatus.user?.userType === LoginType.KaEmployee) {
    path = path.replace("api", "employeeApi");
  }

  if (!headers) {
    throw new Error("useUserOrEmployeeQuery hook can only be used inside of " +
      "components that ensure a user or KaEmployee is signed in");
  }

  return useQuery<Resp>({
    path: path,
    headers,
    method: spec.method,
    body: spec.body,
  }, options);
}